module.exports = __webpack_public_path__ + "img/tracker-icon-active.7d7c34c0.svg";